import { render, staticRenderFns } from "./FullTemplate.vue?vue&type=template&id=4113f536&scoped=true&"
import script from "./FullTemplate.vue?vue&type=script&lang=js&"
export * from "./FullTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FullTemplate.vue?vue&type=style&index=0&id=4113f536&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4113f536",
  null
  
)

export default component.exports